type imageId = string;

export type ImageItem = {
  url: string;
  name: string;
  id: imageId;
};
export type ImageList = Array<ImageItem>;
export type ActiveIndexType = imageId;
export const DEFAULT_IMAGE_INDEX = 0;
